import React, { FC, useCallback, useEffect } from 'react'
import styles from './VariableInput.module.scss'
import KeyboardInput from '../../../../components/_keyboard/_KeyboardInput'
import { useKeyboard } from '../../../../components/_keyboard/KeyboardContext'
import { WheighMaskNumber, WheighToFloat } from '../../../../cross-cutting/WheighMask'
import MoneyInput from '../../../TableMap/components/partialPaymentInput/MoneyInput'
import { useI18n } from '../../../../hooks/useI18n'
export interface IVariableInputProps {
    //propertys
    onChange?: (value: number) => void
    onFocusInput?: (inputRef: React.RefObject<HTMLInputElement>) => void
    error?: string
    price?: number
    onSubmit?: () => void
}
const VariableInput: FC<IVariableInputProps> = ({ onChange, onFocusInput, error, price, onSubmit }) => {
    const { t } = useI18n();
    const { configureKeyboard } = useKeyboard()



    const onChangeHandle = useCallback((value: number) => {
        onChange?.(value)
    }, [onChange])



    useEffect(() => {
        onChange?.(0);
    }, [onChange])


    return (
        <>
            <div id={styles.VariableInput
            } >
                <MoneyInput
                   
                    label={t('inputFields.value')}
                    onChange={onChangeHandle}
                />
            </div>
            {/* <KeyboardModal
                inputRef={inputRef}
            >
                <Keyboard
                    inputRef={inputRef}
                    type='qwerty'
                    onChange={onChange} />
            </KeyboardModal> */}
        </>
    )
}
export default VariableInput
